
import notifications from "@/lib/notifications";
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { AgentResource, AgentFacilityResource } from "../../../models/api/system/agents";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import permissions from "@/security/permissions";
import router from "@/router";

const systemModule = getModule(SystemModule);

@Component
export default class ManageFacilities extends Vue {
  @Prop()
  agent:AgentResource;
    
  @Prop()
  public agentFacilities:Array<AgentFacilityResource>;
  
  filterString:string='';
  loading: boolean = false;
  loadingPage: boolean = false;

  agentFacility: AgentFacilityResource = {
    agentId: null,
    facilityCode: null
  };

  isFacilityModalVisible: boolean = false;
  isDeleteFacilityModalVisible: boolean = false;


  addAgentFacility() {
    this.agentFacility = {
      agentId: this.agent.id,
      facilityCode: null
    };
    this.isFacilityModalVisible = true;
  }

  async saveAgentFacility() {
    try {
      this.agentFacility.agentId = this.agent.id;
      await systemModule.postAgentFacility(this.agentFacility);
      notifications.success("Success", `Facility saved.`);
    } catch (error) {
      console.log(JSON.stringify(error));
      notifications.error("Save Failed", "Unable to save facility.", error);
    }
    this.$emit("updated");
  }

  showAgentFacilityDeleteConfirmation(facilityCode: string) {
    let clone = this.agentFacilities.find(x => x.facilityCode === facilityCode);
    clone = { ...clone };

    this.agentFacility = clone;
    this.isDeleteFacilityModalVisible = true;
  }

  async deleteAgentFacility() {
    try {
      await systemModule.deleteAgentFacility(this.agentFacility.facilityCode);
      notifications.success("Success", `Facility deleted.`);
    } catch (error) {
      notifications.error("Delete Failed", "Unable to delete facility.", error);
    }
    this.$emit("updated");
  }

  done() {
    router.push(`/admin/agents`);
  }
}
